import { useTranslation } from "react-i18next"
import * as yup from "yup"
import { testPhonenumber } from "../../checkout/utils"
import { MIN_PASSWORD_LENGTH } from "../../../util/sizeUtils"
import { translationKeys } from "../../../util/translationKeys"
import {
  noNumberRegex,
  testForEmojis,
  testForEmojisTestExplaination,
} from "./util"
import { useDynamicTranslation } from "../../../hooks/use-dynamic-translation"

export const useSignUpSchemaProperties = () => {
  const { t } = useTranslation()
  const tDynamic = useDynamicTranslation()

  const signUpSchemaProperties = yup.object().shape({
    first_name: yup
      .string()
      .matches(noNumberRegex, {
        message: `${tDynamic(
          translationKeys.comboCheckoutYourDetailsOnlyLettersAllowed,
          [`${t(translationKeys.comboCreateaccountFirst)}`]
        )}`,
        // required will handle
        excludeEmptyString: true,
      })
      .test(
        testForEmojisTestExplaination,
        `${tDynamic(
          translationKeys.comboCheckoutYourDetailsOnlyLettersAllowed,
          [`${t(translationKeys.comboCreateaccountFirst)}`]
        )}`,
        (val) => testForEmojis(val)
      )
      .required(`${t(translationKeys.inputFirstNameErrorMessage)}`),
    last_name: yup
      .string()
      .matches(noNumberRegex, {
        message: `${tDynamic(
          translationKeys.comboCheckoutYourDetailsOnlyLettersAllowed,
          [`${t(translationKeys.comboCreateaccountLast)}`]
        )}`,
        // required will handle
        excludeEmptyString: true,
      })
      .test(
        testForEmojisTestExplaination,
        `${tDynamic(
          translationKeys.comboCheckoutYourDetailsOnlyLettersAllowed,
          [`${t(translationKeys.comboCreateaccountLast)}`]
        )}`,
        (val) => testForEmojis(val)
      )
      .required(`${t(translationKeys.inputLastNameErrorMessage)}`),
    phone_number_prefix: yup.string().required(),
    phone_number: yup
      .string()
      .test(
        "formatTest",
        `${t(translationKeys.inputPhonenumberNotValid)}`,
        (val, ctx) => {
          if (val) {
            return testPhonenumber(ctx.parent.phone_number_prefix, val)
          }
          return true
        }
      )
      .required(`${t(translationKeys.inputPhonenumberNoInput)}`),
    email: yup
      .string()
      .email(`${t(translationKeys.inputEmailErrorMessage)}`)
      .required(`${t(translationKeys.inputEmailNoInput)}`),
    password: yup
      .string()
      .min(
        MIN_PASSWORD_LENGTH,
        `${t(translationKeys.inputPasswordErrorMessage)}`
      )
      .required(`${t(translationKeys.inputPasswordNoInput)}`),
    time_zone: yup.string().required(),
    accepted_terms: yup.array(
      yup
        .mixed()
        .test(
          "terms test",
          t(translationKeys.webTermsNotChecked)!,
          (value, { options: { context, index } }: any) => {
            const isRequired = context!.terms[index].must_be_accepted
            if (!isRequired) {
              return true
            }
            return !!value
          }
        )
    ),
  })
  return signUpSchemaProperties
}
